export default __webpack_public_path__ + "static/parigi-plus-3-31ddcc9ea94b924c0962dfef96844547.jpg";